import React from 'react'
import '../../css/layout/Header.scss'
import Spinner from '../Spinner'

const Header = ({ loading }:{loading:boolean}) => {
  return (
    <header className="header">
      <h3>
        <span className="beta-tag">Aurora status</span>
      </h3>
      {loading && <Spinner size="12" />}
    </header>
  )
}

export default Header
